/* GA — wishlist page renderer. Reads saved handles from window.gaWishlist,
   fetches each product via the Storefront AJAX API, and builds cards that
   reuse the same classes as snippets/ga-product-card.liquid. */
(function () {
  var emptyEl = document.getElementById('ga-wishlist-empty');
  var gridEl = document.getElementById('ga-wishlist-grid');
  if (!emptyEl || !gridEl || !window.gaWishlist) return;

  function formatMoney(cents) {
    var config = window.gaShopMoney || {};
    try {
      return new Intl.NumberFormat(config.locale || undefined, {
        style: 'currency',
        currency: config.currency || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* Locked EUR display price — see sections/ga-wishlist.liquid for
     where window.gaEurLock comes from. Keeps the wishlist showing the
     same frozen EUR prices as the rest of the site instead of the
     real (TRY) backend price /products/{handle}.js returns. */
  function formatLockedEur(cents) {
    var whole = Math.floor(cents / 100);
    var remainder = cents % 100;
    var remainderStr = remainder < 10 ? '0' + remainder : String(remainder);
    return '€' + whole + ',' + remainderStr;
  }

  function priceTextFor(product, variant) {
    var lock = window.gaEurLock || {};
    var variantId = variant ? String(variant.id) : null;
    if (variantId && Object.prototype.hasOwnProperty.call(lock, variantId)) {
      return formatLockedEur(lock[variantId]);
    }
    return formatMoney(product.price);
  }

  function withWidth(url, width) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function buildCard(product) {
    var colorOption = (product.options || []).filter(function (o) {
      return o.name === 'Color';
    })[0];

    var topHtml;
    if (colorOption && colorOption.values.length > 1) {
      topHtml = '<span class="ga-products__colors">' + colorOption.values.length + ' colors</span>';
    } else {
      topHtml = '<span></span>';
    }

    var primaryImg = product.featured_image
      ? withWidth(product.featured_image, 800)
      : '';
    var secondaryImg =
      product.images && product.images[1] ? withWidth(product.images[1], 800) : null;

    var variant = product.variants.filter(function (v) {
      return v.available;
    })[0] || product.variants[0];

    var card = document.createElement('div');
    card.className = 'ga-products__card';
    card.innerHTML =
      '<div class="ga-products__card-top">' +
        topHtml +
        '<button type="button" class="ga-products__wishlist is-active" data-ga-wishlist-toggle data-product-handle="' +
          product.handle +
          '" aria-label="Wishlist" aria-pressed="true">&#9829;</button>' +
      '</div>' +
      '<a href="' + product.url + '" class="ga-products__image-link">' +
        (primaryImg
          ? '<img src="' + primaryImg + '" alt="' + product.title.replace(/"/g, '&quot;') + '" class="ga-products__image ga-products__image--primary" loading="lazy">'
          : '') +
        (false
          ? '<img src="' + secondaryImg + '" alt="" class="ga-products__image ga-products__image--secondary" loading="lazy" aria-hidden="true">'
          : '') +
      '</a>' +
      '<a href="' + product.url + '" class="ga-products__title-link">' + product.title + '</a>' +
      '<div class="ga-products__meta-row">' +
        '<div class="ga-products__price">' + priceTextFor(product, variant) + '</div>' +
        '<form class="ga-products__add-form" data-ga-ajax-add-to-cart data-variant-id="' + (variant ? variant.id : '') + '">' +
          '<button type="submit"' + (product.available ? '' : ' disabled') + '>' +
            (product.available ? 'Add to cart' : 'Sold out') +
          '</button>' +
        '</form>' +
      '</div>';

    return card;
  }

  function removeCard(handle) {
    var toggle = gridEl.querySelector('[data-product-handle="' + handle + '"]');
    if (!toggle) return;
    var card = toggle.closest('.ga-products__card');
    if (card) card.remove();
    if (!gridEl.querySelector('.ga-products__card')) {
      gridEl.hidden = true;
      emptyEl.hidden = false;
    }
  }

  function render() {
    var handles = window.gaWishlist.get();

    if (!handles.length) {
      emptyEl.hidden = false;
      gridEl.hidden = true;
      return;
    }

    emptyEl.hidden = true;
    gridEl.hidden = false;

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (product) {
          if (!product) return;
          gridEl.appendChild(buildCard(product));
        })
        .catch(function () {
          /* product may have been deleted — skip it */
        });
    });
  }

  gridEl.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-ga-ajax-add-to-cart]');
    if (!form) return;
    event.preventDefault();
    var variantId = form.getAttribute('data-variant-id');
    if (!variantId) return;
    var button = form.querySelector('button[type="submit"]');
    var originalLabel = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        button.textContent = 'Added';
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.ga-header__group a[href*="/cart"]').forEach(function (el) {
          el.textContent = 'Cart (' + cart.item_count + ')';
        });
        setTimeout(function () {
          button.textContent = originalLabel;
          button.disabled = false;
        }, 1500);
      })
      .catch(function () {
        button.textContent = originalLabel;
        button.disabled = false;
      });
  });

  document.addEventListener('ga:wishlist:change', function (event) {
    if (!event.detail.active) {
      removeCard(event.detail.handle);
    }
  });

  render();
})();
